import * as React from "react";
import { Tab, Tabs } from "material-ui/Tabs";
import { AddTargetValuesTabs } from "../../../target-types";
import { formatMessage } from "lib/globalize-util";
import { addTargetValuesStyles } from "./styles";
import { TabPanel } from "../../../../product-collection-views/product-collection-grid-view/tool-panels/dimensions-tool-panel/tabs/tab-panel";
import { PasteContainer } from "./paste-container/paste-container";
import { UploadContainer } from "./upload-container/upload-container";
import { TargetsUploaderProvider } from "./targets-uploader-provider";
import { ITargetsData } from "../../../types";

const styles = addTargetValuesStyles();

export const AddTargetValuesContainer = () => {
    const [activeTab, setActiveTab] = React.useState<AddTargetValuesTabs>(AddTargetValuesTabs.Paste);
    const [uploadedTargetsData, setUploadedTargetsData] = React.useState<ITargetsData[]>([]);

    const handleSuccessfulUpload = React.useCallback((uploadedTargetsData: ITargetsData[]) => {
        setUploadedTargetsData(uploadedTargetsData);
        setActiveTab(AddTargetValuesTabs.Paste);
    }, []);

    return (
        <div {...styles} className="container">
            <div className="tabWrapper">
                <Tabs value={activeTab} onChange={(index) => setActiveTab(index)}>
                    <Tab className="tab" label={formatMessage("Paste values")} value={0} />
                    <Tab className="tab" label={formatMessage("Upload spreadsheet")} value={1} />
                </Tabs>
            </div>
            <div style={{ flex: 1 }}>
                <TabPanel index={AddTargetValuesTabs.Paste} value={activeTab} className="tabPanel">
                    <PasteContainer uploadedTargetData={uploadedTargetsData} />
                </TabPanel>
                <TabPanel index={AddTargetValuesTabs.Upload} value={activeTab} className="tabPanel">
                    <TargetsUploaderProvider>
                        <UploadContainer handleSuccessfulUpload={handleSuccessfulUpload} />
                    </TargetsUploaderProvider>
                </TabPanel>
            </div>
        </div>
    );
};
